import { useSelector } from "react-redux";
import BriefcaseIconWhiteBG from "../../assets/images/BriefcaseIconWhiteBG";
import { Constants } from "../../constants/constants";
import { RootState } from "../../store/store";
import { getFormattedDate } from "../../utils/DataTime";
import CameraIcon from "../../assets/images/CameraIcon";
import { useTranslation } from "react-i18next";

export const UserExitProfileFLow = () => {
  const {t,i18n}=useTranslation();
  const userDetail = useSelector(
    (state: RootState) => state?.userDetails?.user
  ); // Access userDetail from Redux store

  return (
    <div className="flex justify-start">
      <div className="mr-2 h-[100px] w-[100px] bg-sideMenuInRegisterUserBackground rounded-lg flex justify-center items-center ">
        <CameraIcon />
      </div>
      <div className="px-4 flex flex-col ">
        <div className="text-black h5" style={{ fontFamily: "Poppins" }}>
          {userDetail?.firstName ?? ""}
        </div>
        <div className="py-1 flex justify-start">
          <BriefcaseIconWhiteBG />
          <div className="px-2 text-black roleText font-nunito">
            {userDetail?.baseRoles?.slice(0, 5).map((role, index) => (
              <span key={index}>
                {role.role.name}
                {index < 4 && ", "}
              </span>
            ))}
          </div>
          </div>
          {userDetail?.professionalDetails?.employeeId && (
            <div className="text-body1Regular roleText font-nunito">
              {`${t('Id')}${userDetail?.professionalDetails?.employeeId}`}
            </div>
          )}
          <div className="font-nunito text-popUpTitleColor quickLinksDescription">
            {`${t('AccountCreatedOn')} ${getFormattedDate(
              userDetail?.createdAt ?? "2024/02/12"
            )}`}
        </div>
      </div>

      {/* <div className="flex flex-col">
        <div className="text-dashBoardTileCountColor staffVerifySubTitle">
          TVS - Synergy Autokraft
        </div>
        <div className="text-dashBoardTileCountColor text7">
          TVS - Synergy Autokraft Pvt Ltd, 4th Phase, 7th Block Extension, Outer
          Ring Rd, near Devagawa Petrol Pump, Phase 3, Banashankari, Bengaluru,
          Karnataka 560085
        </div>
      </div> */}
    </div>
  );
};
